import { InfoOutlined as InfoOutlinedIcon } from "@mui/icons-material";
import { alpha, Tooltip, TooltipProps } from "@mui/material";

type Props = {
  title: string | React.ReactNode;
  placement?: TooltipProps["placement"];
};

const InfoTooltipButton = ({ title, placement = "top" }: Props) => {
  return (
    <Tooltip title={title || ""} placement={placement} arrow>
      <InfoOutlinedIcon
        sx={{
          cursor: "help",
          fontSize: 16,
          color: (theme) => alpha(theme.palette.text.primary, 0.8),
        }}
      />
    </Tooltip>
  );
};

export default InfoTooltipButton;
